// フォント設定画面
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Container } from '@material-ui/core';

import { AttributeHavingFont, isSingleAttribute, isMultiAttribute } from '../redux/cardAttributeDbSlice';
import { FontType } from '../redux/cardAttributeModelIndex';
import { deepCopy } from '../general';
import EditItemFont from './EditItemFont';

type FontDialogProps = {
  open: boolean;
  onClose: () => void;
  item: AttributeHavingFont;
  changeItem: (item: AttributeHavingFont) => void;
}
const FontDialog: React.FC<FontDialogProps> = ({open, onClose, item, changeItem}) => {
  const attributeModel = isSingleAttribute(item) ? 'single' : isMultiAttribute(item) ? 'multi' : 'table';
  const [font, setFont] = useState<FontType>(item.font);

  const fontUpdate = () => {
    const newItem = deepCopy(item);
    newItem.font = font;
    changeItem(newItem);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
      <DialogTitle>項目[{item.name}]のFont設定</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <Container>
          <EditItemFont kind={attributeModel} font={font} setFont={setFont} />
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
        <Button variant="text" color="primary" onClick={fontUpdate}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FontDialog;
